import React from "react";

export default function PageHeader({ title, subtitle, actions, eyebrow }) {
  return (
    <div className="border-b border-border p-6 lg:p-8 flex flex-col md:flex-row md:items-end md:justify-between gap-3" data-testid="page-header">
      <div>
        {eyebrow && (
          <div className="text-[10px] font-mono uppercase tracking-widest text-terracotta mb-2">{eyebrow}</div>
        )}
        <h1 className="font-display text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-1.5 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
